// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"Container__Wrapper__25SFD","Year":"Container__Year__3eLld"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Container/Container.css
// module id = 91
// module chunks = 0